import Image from "next/image"
import React, {useContext} from "react"
import Typography from "../reusable/Typography/Typography"
import Button from "../reusable/components/Button"
import {useTranslation} from "next-i18next"
import {gaCategories, gaEvents} from "../../config/googleAnalytics/events"
import AnalyticsContext from "../../context/AnalyticsContext"
import DataContext from "../../context/DataContext"
import {formatImageSrc} from "../../strapi/strapiHelpers"

function BrandWorldInsurance() {
	const {reactGA} = useContext(AnalyticsContext)
	const {brandWorld} = useContext(DataContext)

	const onHandleGAEvent = () => {
		reactGA.event({
			category: gaCategories.homePage,
			action: gaEvents.readMoreAboutCalingo,
			label: gaEvents.readMoreAboutCalingo,
			nonInteraction: true
		})
	}

	const {t} = useTranslation(["insurance", "common"])
	return (
		<>
			{/* Mobile version */}
			<div className="d-flex d-md-none my-5 ">
				<div style={{borderRadius: "16px", paddingTop: "64px"}}
					className="d-flex flex-column justify-content-between position-relative px-4 pb-4 bg-grey">
					<div style={{left: "50%", transform: "translate(-50%)", top: "-25dvh"}}
						className="col-10 position-absolute p-0">
						{brandWorld.insuranceImage?.data?.attributes?.url ? <Image
							style={{borderRadius: "16px"}}
							src={formatImageSrc(brandWorld.insuranceImage?.data?.attributes?.url)}
							height={568}
							width={851}
							layout="responsive"
							objectFit="cover"
							objectPosition="center"/> : null}
					</div>
					<div style={{marginBottom: "40px"}}
						className="ps-1">
						<Typography style={{marginBottom: "24px"}}
							variant="bodyLg"
							semanticTag="h3">
							{t(brandWorld?.insuranceInfo?.header)}
						</Typography>
						<div className={"row align-items-center"}>
							{brandWorld?.insuranceInfo?.labelWithLogo?.map(({label, logo}, idx) => {
								return (
									<div className={`d-flex flex-direction-row  ps-3 ${idx !== 0 && "pt-2"}`}
										key={idx}>
										<div className="col-auto">
											{logo?.data?.attributes?.url ? <Image src={formatImageSrc(logo?.data?.attributes?.url)}
												layout={"intrinsic"}
												objectFit={"contain"}
												width={24}
												height={24}/> : null}
										</div>
										<Typography className="ms-2"
											variant="bodyLg"
											semanticTag="span">
											{t(`${label}`)}
										</Typography>
									</div>
								)
							})}
						</div>
					</div>
					<div className="d-flex justify-content-between align-items-center">
						<Button
							borderWidth={0}
							paddingX="0"
							isNoUppercase
							icon={<img src="/assets/icons/chevron-right-bg-grey.svg"/>}
							color=""
							spinnerColor="black"
							href={t(brandWorld?.insuranceLink)}
							className={"shadow-none mx-0 border-0 ps-2 "}
							onClick={onHandleGAEvent}
						>
							<Typography className="me-2 text-dark"
								variant="bodyLgBold">{t("read-more", {ns: "common"})}</Typography>
						</Button>
						<div className="d-flex align-items-center justify-content-start gap-3">
							{brandWorld?.brandLogoBlack?.data?.attributes?.url ? <Image src={formatImageSrc(brandWorld?.brandLogoBlack?.data?.attributes?.url)}
								width={111}
								height={21} /> : null}
							<Typography variant="heading3"
								semanticTag="span"
								style={{color: "#00686E"}}>
								{t("calingo")}
							</Typography>
						</div>
					</div>
				</div>
			</div>
			{/* Desktop version */}
			<div className="d-none container d-md-block col-12 px-0">
				<div className="d-flex justify-content-end position-relative">
					<div style={{
						zIndex: 10,
						borderRadius: "16px",
						maxWidth: "534px",
						height: "fit-content",
						top: 0,
						bottom: 0,
						margin: "auto 0"
					}}
					className="d-flex flex-column justify-content-between px-4 pt-4
					 pt-xxl-5 pb-4 position-absolute start-0 bg-grey">
						<div className="ps-1">
							<Typography className="mt-xxl-2 mb-xxl-4"
								variant="bodyLg"
								semanticTag="h3">
								{t(brandWorld.insuranceInfo.header)}
							</Typography>
							<div className={"row align-items-center"}>
								{brandWorld?.insuranceInfo?.labelWithLogo?.map(({logo, label}, idx) => {
									return (
										<div className={`d-flex flex-direction-row  ps-3 ${idx !== 0 && "pt-2"}`}
											key={idx}>
											<div className="col-auto">
												{logo?.data?.attributes?.url ? <Image src={formatImageSrc(logo?.data?.attributes?.url)}
													layout={"intrinsic"}
													objectFit={"contain"}
													width={24}
													height={24}/> : null}
											</div>
											<Typography className="ms-2"
												variant="bodyLg"
												semanticTag="span">
												{t(`${label}`)}
											</Typography>
										</div>
									)
								})}
							</div>
						</div>
						<div className="d-flex justify-content-between align-items-center">
							<Button
								borderWidth={0}
								paddingX="0"
								isNoUppercase
								icon={<img src="/assets/icons/chevron-right-bg-grey.svg"/>}
								color=""
								spinnerColor="black"
								href={t("/calingo")}
								className={"shadow-none mx-0 border-0 ps-2 "}
								onClick={onHandleGAEvent}
							>
								<Typography className="me-2 text-dark"
									variant="bodyLgBold">{t("read-more", {ns: "common"})}</Typography>
							</Button>
							<div className="d-flex align-items-center justify-content-start gap-3">
								{brandWorld?.brandLogoBlack?.data?.attributes?.url ? <Image src={formatImageSrc(brandWorld?.brandLogoBlack?.data?.attributes?.url)}
									width={111}
									height={21} /> : null}
								<Typography variant="heading3"
									semanticTag="span"
									style={{color: brandWorld?.insuranceInfo?.insuranceNameTxtColor}}>
									{t(brandWorld?.insuranceInfo?.insuranceName)}
								</Typography>
							</div>
						</div>
					</div>

					<div className="col-8 p-0">
						{brandWorld.insuranceImage?.data?.attributes?.url ? <Image src={formatImageSrc(brandWorld.insuranceImage?.data?.attributes?.url)}
							height={568}
							style={{borderRadius: "16px"}}
							width={851}
							layout="responsive"
							objectFit="cover"
							objectPosition="center"/> : null}
					</div>

				</div>
			</div></>

	)
}

export default BrandWorldInsurance
